<template>
  <div class="response_table">
    <table>
      <thead style="flex: 0">
      <tr>
        <th scope="col" class="status">
          Status
        </th>
        <th scope="col">
          {{ 'ID / ' + translate('device.name') }}
        </th>
        <th scope="col">
          Device Group
        </th>
        <th scope="col" class="delete" />
      </tr>
      </thead>
      <tbody>
        <tr>
          <div class="new_device__block">
            <div class="new_device" @click="add_device()">
              <span class="mdi mdi-plus-box" />
              <span class="title">
                {{ translate("custom.add_device_in_list") }}
              </span>
            </div>
          </div>
        </tr>

        <tr v-for="(device, index) in device_list" :key="index">
          <td :data-label="translate('status')" class="status" >
            <sis-icon-status :status="device.status" />
          </td>

          <td :data-label="translate('device.name')">
            <router-link :to="{path: '/device/' + device.fid}" class="link">
              <span v-html="device_name(device)"/>
            </router-link>
          </td>

          <td :data-label="translate('group.name')">
            <router-link :to="{path: '/device_list?group=' + device.group?.id}" class="link">
              <span>  {{ device.group?.name}} </span>
            </router-link>
          </td>

          <td class="delete">
            <span class="mdi mdi-close-box red" @click="confirm_delete(device)" title="delete"/>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

import SisIconStatus from "components/UIComponents/Icon/SisIconStatus.vue";
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";
import AddToList from "./Modal/AddToList.vue";

export default {
  name: "CustomDeviceList",
  components: {
    SisIconStatus
  },
  props: ["list_id", "device_list"],
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {
    confirm_delete (device) {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('custom.ask_device_deleted')
        },
        on: {
          close: () => {
            this.$modal.hide('confirm_delete_custom_list')
          },
          confirm: () => {
            this.$emit("delete_device", device)
            this.$modal.hide('confirm_delete_custom_list')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'confirm_delete_custom_list'
      })
    },
    add_device() {
      let t = this.$createElement(AddToList, {
        props: {
          list_id: this.list_id,
          type: "device"
        },
        on: {
          close: () => {
            this.$modal.hide('add_to_list')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'add_to_list'
      })
    },
    device_name (device) {
      let name = "ID: " + device.fid +'<br>'+ device.name2
      if (this.$store.getters.getPermissions.permissionGod) {
        name += '<br>' + device.name
      }
      return name
    },
    save_custom_device_list () {
      let sended_list = {...this.cur_list}
      if (sended_list.devices){
        let devices = []
        for (let device of this.cur_list.devices) {
          devices.push(device?.id)
        }
        sended_list.devices = devices
      }
      this.$http.v1.editCustomDeviceList(this.list_id, {...sended_list},() => {
        this.global_notify('info', this.translate('custom.add_list_success'))
        this.$emit('update')
        this.$store.dispatch('customListUpdate')
      })
    },
  }
}

</script>
<style lang='scss' scoped>
.response_table{
  padding: 0;
  height: 100%;
  margin-top: auto;
  .table_header{
    height: 5%;
    @media (max-width: 768px) {
      height: auto;
    }
    .title{
      margin-bottom: 10px;
      margin-right: 5px;
    }
    span{
      font-size: 12px;
    }
  }
  table{
    height: 100%;
  }
  th.delete{
    width: 50px;
  }
  td.delete{
    width: 50px;
    cursor: pointer;
    .red{
      color: #EB5E28;
    }
  }
}

.new_device {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 10px;
  padding: 10px;
  background: #41b8831f;
  border: 1px dashed #41b883;
  transition: 0.2s;
  margin-right: 10px;
  &:last-child{
    margin-right: 0;
  }
  .mdi {
    font-size: 25px;
  }
  &__block{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &:hover {
    background: #41b8835e;
  }
}
</style>
